<template lang="pug">
  canvas.StarrySky(ref="canvas" :width="containWidth" :height="containHeight")
</template>

<script>
  import {isPhone} from "@/utils/utils";

  export default {
    name: "StarrySky",
    data() {
      return {
        ctx: null,
        startList: [],
        innerWidth: 0,
        innerHeight: 0,
      }
    },
    computed: {
      containWidth() {
        if (isPhone()) {
          return this.innerWidth;
        }
        return this.innerWidth - 17;
      },
      containHeight() {
        if (isPhone()) {
          return 600;
        }
        return this.innerWidth * (870 / 1920);
      },
      startNum() {
      
      },
      center() {
        return {
          x: this.containWidth / 2,
          y: this.containHeight / 2,
        };
      },
    },
    methods: {
      resize() {
        this.innerWidth = window.innerWidth;
        this.innerHeight = window.innerHeight;
      },
    },
    created() {
      this.resize();
    },
    mounted() {
      window.addEventListener("resize", this.resize)
      window.requestAnimFrame = (
      function () {
        return window.requestAnimationFrame;
      }
    )();
      let canvas = this.$refs['canvas'];
      let c = canvas.getContext("2d");
  
      let starScale = 0.0059;
      let numStars = Math.floor(starScale * canvas.width * canvas.height);
      let radius = '0.' + Math.floor(Math.random() * 9) + 1;
      let focalLength = canvas.width * 3;
      let warp = 0;
      let centerX, centerY;
  
      let stars = [], star;
      let i;
  
      let animate = true;
      window.onresize = () => {
        initializeStars();
      };
      initializeStars();
  
      function initializeStars() {
        centerX = canvas.width / 2;
        centerY = canvas.height / 2;
        stars = [];
        numStars = Math.floor(starScale * canvas.width * canvas.height);
        for (i = 0; i < numStars; i++) {
          star = {
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            z: Math.random() * canvas.width,
            o: '0.' + Math.floor(Math.random() * 99) + 1
          };
          stars.push(star);
        }
      }
  
      function moveStars() {
        for (i = 0; i < numStars; i++) {
          star = stars[i];
          star.z--;
      
          if (star.z <= 0) {
            star.z = canvas.width;
          }
        }
      }
  
      function drawStars() {
        var pixelX, pixelY, pixelRadius;
    
        // Resize to the screen
        // if (canvas.width != window.innerWidth || canvas.width != window.innerWidth) {
        //   canvas.width = window.innerWidth;
        //   canvas.height = window.innerHeight;
        //   initializeStars();
        // }
    
        if (warp == 0) {
          // c.fillStyle = "rgba(0,0,0,1)";
          // c.fillRect(0, 0, canvas.width, canvas.height);
          // c.beginPath();
          // c.arc(0, 0, radius, 0, 2 * Math.PI);
          // c.stroke();
          c.clearRect(0, 0, canvas.width, canvas.height);
        }
        c.fillStyle = "rgba(255, 255, 255, " + radius + ")";
        for (i = 0; i < numStars; i++) {
          star = stars[i];
      
          pixelX = (
            star.x - centerX
          ) * (
            focalLength / star.z
          );
          pixelX += centerX;
          pixelY = (
            star.y - centerY
          ) * (
            focalLength / star.z
          );
          pixelY += centerY;
          pixelRadius = 0.2 * (
            focalLength / star.z
          );
      
          // c.fillRect(pixelX, pixelX, pixelRadius, pixelRadius);
          c.beginPath();
          c.arc(pixelX, pixelY, pixelRadius, 0, 2 * Math.PI);
          // c.stroke();
          c.fillStyle = "rgba(255, 255, 255, " + star.o + ")";
          c.fill();
        }
      }
  
      function executeFrame() {
        if (animate) {
          window.requestAnimFrame(executeFrame);
        }
        moveStars();
        drawStars();
      }
  
      executeFrame();
    },
  };
</script>

<style scoped lang="stylus">
  @import "../assets/css/main.styl"
  .StarrySky {
    position absolute
    top 0
    left 0
  }
</style>
